import type {FoodGrubhubCartItem} from '@/lib/food-grubhub/foodGrubhubCartDb'
import type {
  ChoiceCategoryList,
  MenuItemDetails,
} from '@/lib/food-grubhub/foodRestaurantDetailModel'

import flattenSelectedOptions from './flattenSelectedOptions'

export default function buildOptionsText(
  menuItemDetail: MenuItemDetails | undefined,
  selectedOptions: FoodGrubhubCartItem['options'] | undefined,
) {
  const texts: string[] = []

  const flattenedSelectedOptionsMap = flattenSelectedOptions(selectedOptions)
  console.log('flattenSelectedOptionsMap', flattenedSelectedOptionsMap)

  function traverseChoiceCategories(
    choiceCategories: ChoiceCategoryList[] | undefined | null,
    toAppend: string[],
  ) {
    choiceCategories?.forEach(category => {
      console.log('Traversing choice category', category.id, category.name)
      const texts2: string[] = []
      category.choice_option_list?.forEach(option => {
        const selectedOption = flattenedSelectedOptionsMap.get(option.id ?? '')
        console.log('Traversing choice option', option.id, option.description, !!selectedOption)
        if (selectedOption && selectedOption.quantity !== 0) {
          texts2.push(`${option.description} * ${selectedOption.quantity}`)
        }

        if (selectedOption && option.choice_category_list) {
          traverseChoiceCategories(option.choice_category_list, texts2)
        }
      })

      if (texts2.length > 0) {
        toAppend.push(`${category.name} (${texts2.join(', ')})`)
      }
    })
  }

  traverseChoiceCategories(menuItemDetail?.choice_category_list, texts)

  return texts.join(', ')
}
